import type { ReactNode } from 'react'
import { TON, type Ton } from './TonuriB4L'

/** O eticheta de stare, rotunjita, in tonul ei. */
export function Pastila({ ton, children }: { ton: Ton; children: ReactNode }) {
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-2 py-px text-[11.5px] font-semibold ${TON[ton].pastila}`}
    >
      {children}
    </span>
  )
}
